"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./TransactionStatus.css");
var StatusOptions;
(function (StatusOptions) {
    StatusOptions["SCHEDULED"] = "Scheduled";
    StatusOptions["PAID"] = "Paid";
    StatusOptions["CARD_EXPIRING"] = "Card Expiring";
    StatusOptions["LACK_OF_FUNDS"] = "Lack of Funds";
})(StatusOptions || (StatusOptions = {}));
var TransactionStatus = function (_a) {
    var status = _a.status;
    var className = status === StatusOptions.CARD_EXPIRING ||
        status === StatusOptions.LACK_OF_FUNDS
        ? 'warning-status'
        : '';
    return react_1.default.createElement("div", { className: className }, status);
};
exports.default = TransactionStatus;
